import { formatDate } from '@angular/common';
import { NativeDateAdapter } from '@angular/material/core';

export class DatePicker extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    return formatDate(date, 'MMMM YYYY', this.locale);
  }
}
